import React from 'react';
import Hero from '../hero/Hero';

const Footer = () => {
	return (
		<Hero size="is-small" color="is-primary">
			<footer className="footer__container">
				<span className="is-size-5">2018 Batuhan Hıdıroğlu</span>
				<div className="footer__icons">
				<a href="https://wa.me/905321767482" className="is-flex align-items-center">
						<i className="fab fa-whatsapp fa-2x" />
						<span className="pl-1 footer-text-size">(0532) 176 74 82</span>
					</a>
					<a href="https://www.instagram.com/narlideredis" className="is-flex align-items-center">
						<i className="fab fa-instagram fa-2x" />
						<span className="pl-1 footer-text-size">narlideredis</span>
					</a>
					<a href="https://www.facebook.com/dt.batuhanhidiroglu" className="is-flex  align-items-center pl-2">
						<i className="fab fa-facebook-square fa-2x" />
						<span className="pl-1 footer-text-size">dt.batuhanhidiroglu</span>
					</a>
				</div>
			</footer>
		</Hero>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/main/Footer.js